import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { useNavigate } from "react-router-dom";

export const useForgotEmail = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()
    const onBackButtonClick = async () => {
        navigate("/forgot-password")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
    }

    const onContactUsClick = async () => {
        window.open("mailto:support@holifya.com", "_blank");
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "contact_us" }
        });
    }

    const onToHomepageClick = async () => {
        navigate("/login")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "go_to_homepage" }
        });
    }

    return {
        onBackButtonClick,
        onContactUsClick,
        onToHomepageClick,
    }
}